import { get } from "lodash";

export const isFetching = state => state.credentials.integrations.fetching;
export const integrations = state =>
  state.credentials.integrations.integrations;
export const managementIntegration = state =>
  get(integrations(state), "[0].name");
